import { render, staticRenderFns } from "./MedicationIcon.vue?vue&type=template&id=7390b845&scoped=true"
import script from "./MedicationIcon.vue?vue&type=script&lang=js"
export * from "./MedicationIcon.vue?vue&type=script&lang=js"
import style0 from "./MedicationIcon.vue?vue&type=style&index=0&id=7390b845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7390b845",
  null
  
)

export default component.exports